export const getNumericValueFromLocalStorage = (key: string): number | null => {
  const value = localStorage.getItem(key);
  return value ? Number(value) : null;
};
